import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_INSTALLATION_ENTITIES,
  GET_INSTALLATION_ENTITIES_SUCCESS,
  GET_INSTALLATION_ENTITIES_ERROR,
  ADD_INSTALLATION_ENTITY,
  ADD_INSTALLATION_ENTITY_SUCCESS,
  ADD_INSTALLATION_ENTITY_ERROR,
  DELETE_INSTALLATION_ENTITY,
  DELETE_INSTALLATION_ENTITY_SUCCESS,
  DELETE_INSTALLATION_ENTITY_ERROR,
  UPDATE_INSTALLATION_ENTITY,
  UPDATE_INSTALLATION_ENTITY_SUCCESS,
  UPDATE_INSTALLATION_ENTITY_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/entity';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationEntity;
const installationEntity = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
          currentId: initialSettings.currentId,
        };
      }
      switch (action.target) {
        case 'addInstallationEntity':
          key = 'add';
          break;
        case 'updateInstallationEntity':
          key = 'update';
          break;
        case 'deleteInstallationEntity':
          key = 'delete';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST ENTITIES
    case GET_INSTALLATION_ENTITIES:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
        },
      };
    case GET_INSTALLATION_ENTITIES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_INSTALLATION_ENTITIES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          loading: false,
        },
      };
    // ADD ENTITY
    case ADD_INSTALLATION_ENTITY:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
        },
      };
    case ADD_INSTALLATION_ENTITY_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_ENTITY_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          asyncOperation: action.data.data,
        },
      };
    // DELETE ENTITY
    case DELETE_INSTALLATION_ENTITY:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_INSTALLATION_ENTITY_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_ENTITY_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // UPDATE
    case UPDATE_INSTALLATION_ENTITY:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
          idEntity: action.idEntity,
        },
      };
    case UPDATE_INSTALLATION_ENTITY_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_ENTITY_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    default:
      return state;
  }
};

export default installationEntity;



// WEBPACK FOOTER //
// ./reducers/installation/installationEntity.js